import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  inject,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { GeneralFooterComponent } from '../general-footer/general-footer.component';
import { SystemNotificationComponent } from '../system-notification/system-notification.component';
import { LayoutShiftService } from '../../services/layout-shift/layout-shift.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';

@Component({
  selector: 'rrp-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    GeneralFooterComponent,
    SystemNotificationComponent,
  ],
})
export class LayoutComponent {
  private readonly layoutShiftService = inject(LayoutShiftService);
  private readonly router = inject(Router);

  public readonly hideFooter = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith(null),
      map(() => {
        let route = this.router.routerState.snapshot.root;
        while (route.firstChild) {
          route = route.firstChild;
        }

        return route.data['hideFooter'] === true;
      }),
    ),
    { initialValue: false },
  );

  @HostBinding('class.has-system-notification')
  private get hasNotification(): boolean {
    return this.layoutShiftService.containsSystemNotification();
  }
}
